import {
    IAfterGuiAttachedParams,
    IDoesFilterPassParams,
    IFilterComp,
    IFilterParams,
    IFloatingFilterComp,
    IFloatingFilterParams,
} from '@ag-grid-community/core';

// Display labels for the floating filter
const STATUS_LABELS: Record<string, string> = {
    '': 'All',
    'intake pending admitted': 'Active',
    intake: 'Intake',
    pending: 'Pending',
    admitted: 'Admitted',
    transferred: 'Transferred',
    discharged: 'Discharged',
    'non admit': 'Non Admit',
};

export class StatusFilter implements IFilterComp {
    filterParams!: IFilterParams;
    filterText!: string | null;
    gui!: HTMLDivElement;
    eFilterText: any;

    init(params: IFilterParams) {
        this.filterParams = params;
        this.filterText = null;
        this.setupGui(params);
    }

    setupGui(params: IFilterParams) {
        this.gui = document.createElement('div');
        this.gui.innerHTML = `<div class="ag-person-filter">
                    <label for="filterText">
                        <select id="filterText">
                            <option value="">All</option>
                            <option value="intake pending admitted">Active</option>
                            <option value="intake">Intake</option>
                            <option value="pending">Pending</option>
                            <option value="admitted">Admitted</option>
                            <option value="transferred">Transferred</option>
                            <option value="discharged">Discharged</option>
                            <option value="non admit">Non Admit</option>
                        </select>
                    </label>
            </div>
        `;

        const listener = (event: any) => {
            this.filterText = event.target.value;
            params.filterChangedCallback();
        };

        this.eFilterText = this.gui.querySelector('#filterText');
        this.eFilterText.addEventListener('change', listener);
        this.eFilterText.addEventListener('paste', listener);
        this.eFilterText.addEventListener('input', listener);
    }

    getGui() {
        return this.gui;
    }

    doesFilterPass(params: IDoesFilterPassParams) {
        const { node } = params;
        const entries = this.filterParams.getValue(node)?.toString().toLowerCase();

        if (!entries) {
            return false;
        }

        if (!this.filterText) {
            return true;
        }

        const filterWords = this.filterText.toLowerCase().split(' ');

        return filterWords.some((word) => entries.includes(word));
    }

    isFilterActive() {
        return this.filterText != null && this.filterText !== '';
    }

    getModel() {
        if (!this.isFilterActive()) {
            return null;
        }

        return { value: this.filterText };
    }

    setModel(model: any) {
        const newValue = model == null ? null : model.value;
        this.eFilterText.value = newValue;
        this.filterText = newValue;
    }

    afterGuiAttached(params?: IAfterGuiAttachedParams): void {
        if (!params?.suppressFocus) {
            // focus the input element for keyboard navigation
            this.eFilterText.focus();
        }
    }
}

export class StatusFloatingFilter implements IFloatingFilterComp {
    private eGui!: HTMLDivElement;
    private eSelect!: HTMLSelectElement;
    private params!: IFloatingFilterParams<StatusFilter>;

    init(params: IFloatingFilterParams<StatusFilter>) {
        this.params = params;
        this.eGui = document.createElement('div');
        this.eGui.style.width = '100%';
        this.eGui.style.height = '100%';
        this.eGui.style.display = 'flex';
        this.eGui.style.alignItems = 'center';

        this.eSelect = document.createElement('select');
        this.eSelect.style.width = '100%';
        this.eSelect.style.height = '24px';
        this.eSelect.style.fontSize = '12px';
        this.eSelect.className = 'ag-input-field-input ag-text-field-input';

        // Add options
        Object.entries(STATUS_LABELS).forEach(([value, label]) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = label;
            this.eSelect.appendChild(option);
        });

        this.eSelect.addEventListener('change', () => {
            this.params.parentFilterInstance((instance) => {
                instance.setModel(this.eSelect.value ? { value: this.eSelect.value } : null);
                instance.filterParams.filterChangedCallback();
            });
        });

        this.eGui.appendChild(this.eSelect);
    }

    getGui() {
        return this.eGui;
    }

    onParentModelChanged(parentModel: { value: string } | null) {
        this.eSelect.value = parentModel?.value ?? '';
    }
}
